import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { BusySnackbarComponent, BusySnackbarData } from '../components/busy-snackbar/busy-snackbar.component';

export interface BusySnackbarConfig {
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
}

@Injectable({ providedIn: 'root' })
export class BusySnackbarService {
  private static readonly DEFAULT_DURATION_MS = 1500;
  private static readonly DEFAULT_HORIZONTAL_POSITION: MatSnackBarHorizontalPosition = 'right';
  private static readonly DEFAULT_VERTICAL_POSITION: MatSnackBarVerticalPosition = 'bottom';

  private readonly snackBar = inject(MatSnackBar);
  private readonly translate = inject(TranslateService);

  show(translationKey: string, config?: BusySnackbarConfig): MatSnackBarRef<BusySnackbarComponent> {
    const data: BusySnackbarData = {
      message: this.translate.instant(translationKey)
    };

    return this.snackBar.openFromComponent(BusySnackbarComponent, {
      data,
      horizontalPosition: config?.horizontalPosition ?? BusySnackbarService.DEFAULT_HORIZONTAL_POSITION,
      verticalPosition: config?.verticalPosition ?? BusySnackbarService.DEFAULT_VERTICAL_POSITION,
      duration: BusySnackbarService.DEFAULT_DURATION_MS
    });
  }
}
